'use client';

import { Button } from '@ui/components/button';
import { AppCard, PageLayout } from '@ui/components/layouts';
import { PageContentLoading } from '@/src/components/PageContentLoading';
import type { HomeProps } from '@modules/home/containers/home_container';

export function Home({
  isLoading,
  welcomeTitle,
  welcomeSubtitle,
  hubIntro,
  gardensLabel,
  gardensHint,
  plantsLabel,
  plantsHint,
  settingsLabel,
  settingsHint,
  onOpenGardens,
  onOpenPlants,
  onOpenSettings,
}: HomeProps) {
  if (isLoading) {
    return <PageContentLoading />;
  }

  return (
    <PageLayout title={welcomeTitle} description={welcomeSubtitle} maxWidth={720}>
      <p className="text-muted-foreground mb-2 text-base">{hubIntro}</p>

      <div className="flex flex-col gap-4">
        <AppCard className="p-4">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="flex min-w-[200px] flex-1 flex-col gap-1">
              <h3 className="text-lg font-semibold">{gardensLabel}</h3>
              <p className="text-muted-foreground text-sm">{gardensHint}</p>
            </div>
            <Button size="lg" onClick={onOpenGardens}>
              {gardensLabel}
            </Button>
          </div>
        </AppCard>

        <AppCard className="p-4">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="flex min-w-[200px] flex-1 flex-col gap-1">
              <h3 className="text-lg font-semibold">{plantsLabel}</h3>
              <p className="text-muted-foreground text-sm">{plantsHint}</p>
            </div>
            <Button size="lg" onClick={onOpenPlants}>
              {plantsLabel}
            </Button>
          </div>
        </AppCard>

        <AppCard className="p-4">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="flex min-w-[200px] flex-1 flex-col gap-1">
              <h3 className="text-lg font-semibold">{settingsLabel}</h3>
              <p className="text-muted-foreground text-sm">{settingsHint}</p>
            </div>
            <Button variant="outline" size="lg" onClick={onOpenSettings}>
              {settingsLabel}
            </Button>
          </div>
        </AppCard>
      </div>
    </PageLayout>
  );
}
